import { Compiler, Injectable, Injector, NgModuleFactory, NgModuleRef } from '@angular/core';
import { Utility } from '../utility';

@Injectable({
  providedIn: 'root'
})

export class SocketIOService {

  /**
   * 主要为了异步加载socket.io-client，并维护多个socket链接
   */
  constructor(
    private _utility:Utility
    ) { }



  async getOrCreateSocket(uid:number){
    const { Socket } = await import("ngx-socket-io");
    return new Socket({
      url:this._utility.GetHost("https://chat.{Host}"),
      options: {
        query: {
          lb: this._utility.GUID(),
          uid: uid.toString(),
        },
        reconnectionAttempts: 10,
        "transports": ["websocket", "polling"]
      }
    });
  }
  
}
